/**
 * This code was  originally copied from the lexical playground source code on github
 * And so it doesn't follow our code style
 * https://github.com/facebook/lexical/tree/main/packages/lexical-playground
 *
 */

import type {
    DOMConversionMap,
    DOMConversionOutput,
    DOMExportOutput,
    EditorConfig,
    LexicalEditor,
    LexicalNode,
    RangeSelection,
    SerializedElementNode,
} from "lexical";
import { $createParagraphNode, $createTextNode, $isElementNode, ElementNode, TextNode } from "lexical";

import { $isConditionalContainerNode } from "./ConditionalContainerNode";
import { $isConditionalContentNode } from "./ConditionalContentNode";

type SerializedConditionalTitleNode = SerializedElementNode;

export function convertSummaryElement(domNode: HTMLElement): DOMConversionOutput | null {
    const node = $createConditionalTitleNode();
    return {
        node,
    };
}

export class ConditionalTitleNode extends ElementNode {
    static getType(): string {
        return "conditional-title";
    }

    static clone(node: ConditionalTitleNode): ConditionalTitleNode {
        return new ConditionalTitleNode(node.__key);
    }

    createDOM(config: EditorConfig, editor: LexicalEditor): HTMLElement {
        const dom = document.createElement("summary");
        dom.classList.add("Conditional__title");
        return dom;
    }

    updateDOM(prevNode: ConditionalTitleNode, dom: HTMLElement): boolean {
        return false;
    }

    static importDOM(): DOMConversionMap | null {
        return {
            summary: (domNode: HTMLElement) => {
                return {
                    conversion: convertSummaryElement,
                    priority: 1,
                };
            },
        };
    }

    static importJSON(serializedNode: SerializedConditionalTitleNode): ConditionalTitleNode {
        return $createConditionalTitleNode();
    }

    exportDOM(): DOMExportOutput {
        const element = document.createElement("summary");
        return { element };
    }

    exportJSON(): SerializedConditionalTitleNode {
        return {
            ...super.exportJSON(),
            type: "conditional-title",
            version: 1,
        };
    }

    collapseAtStart(_selection: RangeSelection): boolean {
        this.getParentOrThrow().insertBefore(this);
        return true;
    }

    insertNewAfter(_: RangeSelection, restoreSelection = true): ElementNode {
        const containerNode = this.getParentOrThrow();

        if (!$isConditionalContainerNode(containerNode)) {
            throw new Error("RepeatableTitleNode expects to be child of RepeatableContainerNode");
        }

        if (containerNode.getOpen()) {
            const contentNode = this.getNextSibling();
            if (!$isConditionalContentNode(contentNode)) {
                throw new Error("RepeatableTitleNode expects to have RepeatableContentNode sibling");
            }

            const firstChild = contentNode.getFirstChild();
            if ($isElementNode(firstChild)) {
                return firstChild;
            } else {
                const paragraph = $createParagraphNode();
                contentNode.append(paragraph);
                return paragraph;
            }
        } else {
            const paragraph = $createParagraphNode();
            containerNode.insertAfter(paragraph, restoreSelection);
            return paragraph;
        }
    }
}

export function $createConditionalTitleNode(): ConditionalTitleNode {
    return new ConditionalTitleNode();
}

export function $isConditionalTitleNode(node: LexicalNode | null | undefined): node is ConditionalTitleNode {
    return node instanceof ConditionalTitleNode;
}
